import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import {NavLink,useHistory} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';

//Start PasswordUpdated component code ...
export default function PasswordUpdatedV2() {
    const [spacing, setSpacing] = React.useState(2);
    const [errPopUp, setErrPopUp] = React.useState(false);
    
    let history = useHistory();
    const handleChange = (event) => {
      setSpacing(Number(event.target.value));
    };
    const validateForm = async e => {
      e.preventDefault();      
      history.push("/reset_password");      
    }  
    const ShowErrPopUP = () => {
        setErrPopUp(false);
    };
  return (
    <React.Fragment>
      {/* <Header/> */}
    <CssBaseline />
    <div className="signin-main">
    <Container maxWidth="sm" className="user-form-container">
      <Typography component="div">
      <div className="form-logo">
      <NavLink to="/" title='Close'><img className="close-icon" src={require('../../assets/icons/close.svg')} /></NavLink>
      <img src={require('../../assets/images/dataPointLogo.svg')} className="form-icon"></img>
      </div>
      <form className="root-form" noValidate autoComplete="off" onSubmit={e => validateForm(e)}>  
        <h3 className="h3-title">Update password</h3>
        <Grid container className="root-box">
        <Grid item xs={12}>
            <Grid container justify="center" spacing={spacing}> 
            <Grid xs={12} item>
                <Paper className="paper">
                    <div className="form-alert-success"> 
                        <ErrorMessage title={'Password update complete'} message={'You have successfully updated your password! You are back in business, please sign in to continue with DataPoint.'} visible={ShowErrPopUP} show={true} msgType={'success'} /> 
                    </div>
                </Paper>
            </Grid>
            <Grid xs={12} item>
                <Button type="button" variant="outlined" id="signUp_btn" data-testid="signUp_btn" className="blue-btn" onClick={() => history.push('/sign_in')}>
                    Sign in
                </Button>
            </Grid>       
            </Grid>
        </Grid>
        </Grid>  
        </form>
      </Typography>
    </Container>
    </div>
  </React.Fragment>    
  );
}
//Start PasswordUpdated component code ...